module.exports = __webpack_public_path__ + "img/bubble.108657a2.png";